import React from 'react';
import { Phone, } from 'lucide-react';

const Manyara = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white text-[#2f4f2f] py-4 px-6 border-b border-[#9acd32]/20">
        <h1 className="text-2xl font-bold">LAKE MANYARA NATIONAL PARK</h1>
      </header>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 py-8">
        {/* Main Heading */}
        <h2 className="text-3xl font-bold text-[#2f4f2f] mb-6">
          Lake Manyara National Park - Tanzania Safari Tours
        </h2>

        {/* Main Description */}
        <div className="mb-8">
          <p className="text-gray-700 leading-relaxed mb-4">
            <strong>Lake Manyara National Park</strong> is located in northern Tanzania, approximately 126 kilometres west of Arusha Town. Spanning 330 
            square kilometres, the park features a lake that covers 220 square kilometres during the rainy season. Adjacent to Tarangire 
            National Park via the Kwakuchinja corridor, the two parks share a diverse range of wildlife that can be easily observed near the 
            road, making it Lake Manyara National Park's most convenient wildlife viewing area.
          </p>
          
          <p className="text-gray-700 leading-relaxed mb-4">
            Although relatively small, Lake Manyara National Park is renowned for its breathtaking beauty and rich biodiversity, particularly its 
            giraffe. The park is home to a large population of elephants, wildebeest, giraffes, and buffalo, along with significant numbers of 
            zebras, impalas, warthogs, and antelopes. The escarpment slopes provide habitat for tree-olive bark, oil-nut and big-springs.
          </p>
          
          <p className="text-gray-700 leading-relaxed">
            In <strong>Ernest Hemingway</strong>'s observation, Lake Manyara offers an old environment for Manyara's lion pride, famous for their tree-climbing 
            behavior. Additionally, large groups of baboons, often numbering in the hundreds, are a common sight and a highlight for many 
            visitors.
          </p>
        </div>

        {/* Activities Section */}
        <div className="mb-8">
          <h3 className="text-2xl font-bold text-[#2f4f2f] mb-4">Activities in Lake Manyara National Park</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            Visitors can enjoy a variety of activities including <span className="text-[#9acd32] font-semibold">game drives</span> both day and night, canoeing when water levels are high, cultural 
            visits, picnics, local Maasai dances, mountain biking, abseiling, and forest walks on the escarpment outside the park.
          </p>
          
          {/* Call to Action Box */}
          <div className="p-6 border border-[#9acd32]/20 rounded-lg">
            <p className="text-center font-bold text-[#2f4f2f] mb-2">
              Ready to Plan a Tanzania Safari? Talk to a Travel Advisor Now (Call/WhatsApp)
            </p>
            <p className="text-center text-2xl font-bold text-[#2f4f2f]">
              <Phone className="inline mr-2" size={20} />
              <a href="tel:+255753182737" className="text-[#9acd32] hover:text-[#228b22] transition-colors">+255 753 182 737</a>
            </p>
          </div>
        </div>

        {/* Getting There Section */}
        <div className="mb-8">
          <h3 className="text-2xl font-bold text-[#2f4f2f] mb-4">Getting There</h3>
          <p className="text-gray-700 leading-relaxed">
            The park is accessible by road or via chartered or scheduled flights from Arusha, typically en route to the <a href="/destinations/serengeti" className="text-[#9acd32] hover:text-[#228b22] transition-colors">Serengeti National Park</a> 
            and <a href="/destinations/Ngorongoro" className="text-[#9acd32] hover:text-[#228b22] transition-colors">Ngorongoro Crater</a>.
          </p>
        </div>

        {/* Safari Packages Section */}
        <div className="mb-8">
          <h3 className="text-2xl font-bold text-[#2f4f2f] mb-6">Our Top Tanzania Safari Packages to Lake Manyara National Park</h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Package 1 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <img 
                src="/15.jpg" 
                alt="3 Days Tanzania Luxury Safari" 
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <div className="bg-[#9acd32] text-[#2f4f2f] px-3 py-1 rounded text-sm inline-block mb-2">
                  3 Days Tanzania Luxury Safari
                </div>
              </div>
            </div>

            {/* Package 2 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <img 
                src="/2.jpg" 
                alt="3 Days Best of Tanzania Safari" 
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <div className="bg-[#9acd32] text-[#2f4f2f] px-3 py-1 rounded text-sm inline-block mb-2">
                  3 Days Best of Tanzania Safari
                </div>
              </div>
            </div>

            {/* Package 3 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <img 
                src="/57.jpg" 
                alt="3 Days Lake Manyara & Serengeti Wildlife Safari" 
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <div className="bg-[#9acd32] text-[#2f4f2f] px-3 py-1 rounded text-sm inline-block mb-2">
                  3 Days Lake Manyara & Serengeti Wildlife Safari
                </div>
              </div>
            </div>

            {/* Package 4 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <img 
                src="/59.jpg" 
                alt="3 Days Tanzania Wildlife Safari" 
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <div className="bg-[#9acd32] text-[#2f4f2f] px-3 py-1 rounded text-sm inline-block mb-2">
                  3 Days Tanzania Wildlife Safari
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Manyara;